export default function getDimensionsFromImageDataUrl(
  dataURL: string
): Promise<IDimensions> {
  return new Promise<IDimensions>((resolve) => {
    const img = new Image();
    img.onload = () => {
      resolve({
        height: img.naturalHeight,
        width: img.naturalWidth,
      });
    };
    img.src = dataURL;
  });
}

interface IDimensions {
  height: number;
  width: number;
}
